import { render, staticRenderFns } from "./roles-and-permissions-list.html?vue&type=template&id=64303f0b&scoped=true&external"
import script from "./roles-and-permissions-list.js?vue&type=script&lang=js&external"
export * from "./roles-and-permissions-list.js?vue&type=script&lang=js&external"
import style0 from "./roles-and-permissions-list.scss?vue&type=style&index=0&id=64303f0b&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64303f0b",
  null
  
)

export default component.exports